module.exports = __webpack_public_path__ + "img/zxmore.8dff2787.png";